import * as apiActions from "./apiActions";
import * as apiValues from "../constants/apiValues";
import * as pageActions from "./pageActions";


export const initPageGetInvolved = () => (dispatch) => {
  dispatch(pageActions.loadPageStart());

  return apiActions.loadSingleType(apiValues.nref.pageGetInvolved.endpoint)
    .then(result => {
      let page = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.pageGetInvolved.fieldsUsed);
      page.contact = apiActions.itemSelectCamelCaseKeys(page.contact, apiValues.nref.contact.fieldsUsed);
      page.cardListA = apiActions.itemSelectCamelCaseKeys(page.cardListA, apiValues.nref.mListCards.fieldsUsed);
      page.cardListB = apiActions.itemSelectCamelCaseKeys(page.cardListB, apiValues.nref.mListCards.fieldsUsed);
      page.cardListC = apiActions.itemSelectCamelCaseKeys(page.cardListC, apiValues.nref.mListCards.fieldsUsed);
      return page;
    })
    .then(results => {
      return dispatch(pageActions.loadPageSuccess(results));
    })
};
